import styled from 'styled-components';
import { select } from '../../core/themev2';

const ContentLayout = styled.div`
  border-radius: 12px;
  background-color: ${select('grayLight')};
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export { ContentLayout };
